import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth_service.service';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/models/app-state.model';
import { ShoppingItem } from 'src/app/store/models/shopping-item.model';
import { AddItemAction, NewListAction, UpdateNotifications, UpdateQuantityAction } from 'src/app/store/actions/shopping.actions';
import { Observable, Subscription } from 'rxjs';
import { OrderService } from 'src/app/services/order.service';
import { OrderServicePlan } from 'src/app/models/order_service_plan.model';
import { Order } from 'src/app/models/order.model';
import { OrderServicePlanService } from 'src/app/services/order_service_plan.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserNotificationService } from 'src/app/services/user-notification.service';
import { PaginationHeaderData } from 'src/app/models/pagination-header-data.model';
import { MatFormField, MatLabel, MatError } from "@angular/material/select";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { head } from 'lodash';


@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [
        ReactiveFormsModule, 
        MatFormField, 
        MatLabel, 
        MatError, 
        MatProgressBar, 
        MatFormFieldModule, 
        MatInputModule, 
        MatButtonModule,
        RouterLink
    ]
})
export class LoginComponent implements OnInit, OnDestroy {

    loginForm = new FormGroup({
        emailAddress: new FormControl('', [Validators.required, Validators.email]),
        password: new FormControl('', Validators.required),
    });

    loading = false;
    submitted = false;
    isLoginFailed = false;
    errorMessage = '';
    return = '';
    storeValues: Observable<ShoppingItem[]> | undefined;
    storeValuesList: ShoppingItem[] = [];
    updatedStoreValuesList: ShoppingItem[] = [];
    dataBaseShoppingItems: OrderServicePlan[] = [];
    pendingOrder: Order = new Order();
    storeSub: any;

    constructor(
        private router: Router,
        private tokenStorageService: TokenStorageService,
        private loginService: AuthService,
        private route: ActivatedRoute,
        private store: Store<AppState>,
        private orderServicePlanService: OrderServicePlanService,
        private notificationSnackBar: MatSnackBar,
        private notificationService: UserNotificationService
    ) { }

    ngOnDestroy(): void {
        if (!this.store) {
            this.storeSub.unsubscribe();
        }
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => this.return = params.return || '/home');
    }

    get formControls(): { [p: string]: AbstractControl } {
        return this.loginForm.controls;
    }

    onSubmit(): void {
        this.loading = true;
        this.tokenStorageService.clearToken();

        const username = this.formControls.emailAddress.value;
        const password = this.formControls.password.value;
        const basic = btoa(`${username}:${password}`); 

        this.loginService.login(basic).subscribe(
            user => {
                this.loading = false;
                this.isLoginFailed = false;
                this.tokenStorageService.saveToken(user.token);
                this.tokenStorageService.saveUser(user);
                const getUser = this.tokenStorageService.getUser();

                if (getUser && Object.keys(getUser).length > 0 && this.tokenStorageService.getToken() != null) {
                    this.getNotifications();
                    this.combineCarts();
                }
            },
            (error) => {
                this.loading = false;
                this.isLoginFailed = true;
                this.errorMessage = error;
            }
        );
    }

    getNotifications(): void {
        const queryParams = new Map([
            ["isRead", 'false'],
			['userId', this.tokenStorageService.getUser().id]
        ]);
        this.notificationService.getPaginatedNotifications([], queryParams).subscribe((result) => {
            let paginationData: PaginationHeaderData = JSON.parse(result.headers.get('x-pagination'));
            const newNotificationCount = paginationData.totalCount;
            let notificationMessage = '';
            
            if(newNotificationCount > 0) {
                notificationMessage = 'You have ' + newNotificationCount + ' unread notifications';
            } else {
                notificationMessage = 'No new notifications';
            }

            this.notificationSnackBar.open(notificationMessage, 'Close', {
                horizontalPosition: 'center',
                verticalPosition: 'top',
                duration: 10000,
                panelClass: ['success-snack-bar'],
              });

              this.store.dispatch(new UpdateNotifications(newNotificationCount));
        });
        
        
    }

    combineCarts(): void {
        this.storeValues = this.store.select(store => store.shopping.items);
        const queryParams = new Map([
            ["userId", this.tokenStorageService.getUser().id],
            ["status", 'pending'],
        ]);

        this.storeSub = this.storeValues.subscribe(store => {
            this.storeValuesList = [...store];
            this.storeValuesList = JSON.parse(JSON.stringify(this.storeValuesList));
            
        });

        this.orderServicePlanService.put(['SyncCarts'], this.storeValuesList).subscribe((updateShoppingList) => {
            this.store.dispatch(new NewListAction(updateShoppingList));
            if(this.storeSub != undefined) {
                this.storeSub.unsubscribe;
            }
            
            this.navigateToProperURL();
        });

    }

    navigateToProperURL(): void {

        if (localStorage.getItem('ReturnToCheckout') == 'true') {
            this.router.navigate(['checkout']);
        } else if (localStorage.getItem('ReturnToProductView') == 'true') {
            this.router.navigate(['product-view/' + localStorage.getItem('ProductId')]);
        } else {
            this.router.navigate([this.return]);
        }
    }
}
